/* ─── FESTIVE Custom Header — Interactions ────────────────────────
   Ticker · Desktop Mega Menu · Mobile Drawer (2-level)
   Nav data is driven by section blocks in the Shopify admin.
   ──────────────────────────────────────────────────────────────── */

(() => {
  'use strict';

  // ── Read data from the Liquid-rendered JSON island ───────────────
  function getHeaderData() {
    const el = document.getElementById('fhdr-nav-data');
    if (!el) return { ticker: [], nav: [] };
    try { return JSON.parse(el.textContent); } catch (e) { return { ticker: [], nav: [] }; }
  }

  const { ticker: TICKER_MESSAGES, nav: NAV } = getHeaderData();

  // ── SVG Icons ───────────────────────────────────────────────────
  const svg = {
    user:   `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>`,
    cart:   `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1.2 11a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7z"/><path d="M9 7a3 3 0 1 1 6 0"/></svg>`,
    heart:  `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
    search: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>`,
    burger: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>`,
    x:      `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="m6 6 12 12M18 6 6 18"/></svg>`,
    chev:   `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>`,
    backChev: `<svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    cart20: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1.2 11a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7z"/><path d="M9 7a3 3 0 1 1 6 0"/></svg>`,
    search20: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>`,
    user15: `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>`,
    heart15: `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>`,
    search15: `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>`,
  };

  // ── Ticker ───────────────────────────────────────────────────────
  function initTicker() {
    const ticker = document.getElementById('fhdr-ticker');
    if (!ticker) return;

    const textEl = ticker.querySelector('.fhdr-ticker__text');
    const dots   = ticker.querySelectorAll('.fhdr-ticker__dot');
    if (!textEl || !dots.length) return;

    const MESSAGES = TICKER_MESSAGES.filter(Boolean);
    if (MESSAGES.length <= 1) return;

    let cur = 0;

    function next() {
      textEl.style.opacity = '0';
      setTimeout(() => {
        cur = (cur + 1) % MESSAGES.length;
        textEl.textContent = MESSAGES[cur];
        textEl.style.opacity = '1';
        dots.forEach((d, i) => d.classList.toggle('fhdr-ticker__dot--active', i === cur));
      }, 340);
    }

    setInterval(next, 4000);
  }

  // ── Mega Menu ────────────────────────────────────────────────────
  function buildColBlock(col) {
    let html = '<div>';

    if (col.head_thumb) {
      html += `<a href="${col.head_href || '#'}" class="fhdr-col-head-card">
        <div class="fhdr-col-head-img"><img src="${col.head_thumb}" alt="${col.head}" loading="lazy"></div>
        <span class="fhdr-col-head-label">${col.head}</span>
      </a>`;
    } else {
      html += `<div class="fhdr-col-head">${col.head}</div>`;
    }

    if (col.links.length) {
      html += `<div class="fhdr-links-list fhdr-links-list--plain">`;
      col.links.forEach(lk => {
        const cls = ['fhdr-plain-link',
          lk.bold ? 'fhdr-plain-link--bold' : '',
          lk.cta  ? 'fhdr-plain-link--cta'  : ''].filter(Boolean).join(' ');
        html += `<a href="${lk.href || '#'}" class="${cls}">${lk.text}</a>`;
      });
      html += '</div>';
    }

    if (col.extra) {
      html += `<div class="fhdr-col-extra">
        <div class="fhdr-col-head">${col.extra.head}</div>
        <div class="fhdr-links-list fhdr-links-list--plain">`;
      col.extra.links.forEach(lk => {
        const cls = ['fhdr-plain-link',
          lk.bold ? 'fhdr-plain-link--bold' : '',
          lk.cta  ? 'fhdr-plain-link--cta'  : ''].filter(Boolean).join(' ');
        html += `<a href="${lk.href || '#'}" class="${cls}">${lk.text}</a>`;
      });
      html += '</div></div>';
    }

    html += '</div>';
    return html;
  }

  function buildMegaPanel(item) {
    const cols   = item.cols   || [];
    const photos = item.photos || [];

    let titlesHtml = '';
    cols.forEach(col => {
      let linksHtml = '';
      col.links.forEach(lk => {
        const cls = ['fhdr-plain-link',
          lk.bold ? 'fhdr-plain-link--bold' : '',
          lk.cta  ? 'fhdr-plain-link--cta'  : ''].filter(Boolean).join(' ');
        linksHtml += `<a href="${lk.href || '#'}" class="${cls}">${lk.text}</a>`;
      });

      // No image: reuse the same title styling (typography, color, hover) minus
      // the image block. Render a real anchor when a URL is available, falling
      // back to a non-clickable div otherwise.
      const hasHeadUrl = col.head_href && col.head_href !== '#';
      const headHtml = col.head_thumb
        ? `<a href="${col.head_href || '#'}" class="fhdr-mega-col-title">
            <div class="fhdr-col-head-img"><img src="${col.head_thumb}" alt="${col.head}" loading="lazy"></div>
            <span>${col.head}</span>
           </a>`
        : hasHeadUrl
          ? `<a href="${col.head_href}" class="fhdr-mega-col-title fhdr-mega-col-title--no-img"><span>${col.head}</span></a>`
          : `<div class="fhdr-mega-col-title fhdr-mega-col-title--no-img"><span>${col.head}</span></div>`;

      titlesHtml += `<div class="fhdr-mega-col-section">
        ${headHtml}
        ${linksHtml ? `<div class="fhdr-links-list fhdr-links-list--plain">${linksHtml}</div>` : ''}
      </div>`;
    });

    let photosHtml = '';
    photos.forEach(ph => {
      const inner = `<div class="fhdr-photo-card__img-wrap${ph.contain ? ' fhdr-photo-card__img-wrap--contain' : ''}">
          <img src="${ph.src}" alt="${ph.caption || ''}" loading="lazy">
        </div>
        ${ph.caption ? `<p class="fhdr-photo-card__caption">${ph.caption}</p>` : ''}`;
      photosHtml += ph.link
        ? `<a class="fhdr-photo-card fhdr-photo-card--link" href="${ph.link}">${inner}</a>`
        : `<div class="fhdr-photo-card">${inner}</div>`;
    });

    const html = `<div class="fhdr-mega-inner">
      ${titlesHtml ? `<div class="fhdr-mega-titles">${titlesHtml}</div>` : ''}
      ${photosHtml ? `<div class="fhdr-mega-photos">${photosHtml}</div>` : ''}
    </div>`;
    return html;
  }

  function initMegaMenu() {
    const mega   = document.getElementById('fhdr-mega');
    const border = document.getElementById('fhdr-bottom-border');
    if (!mega) return;

    // Pre-render all panels (hidden) into the mega container
    const panels = {};
    NAV.forEach(item => {
      if (!item.cols.length && !item.photos.length) return;
      const div = document.createElement('div');
      div.className = 'fhdr-mega-panel';
      div.setAttribute('data-panel', item.label);
      div.style.display = 'none';
      div.innerHTML = buildMegaPanel(item);
      mega.appendChild(div);
      panels[item.label] = div;
    });

    const navItems = document.querySelectorAll('.fhdr-nav-item[data-nav]');
    let openT = null, closeT = null, activeLabel = null;

    function show(label) {
      const panel = panels[label];
      if (!panel) return;
      // Hide all others
      Object.values(panels).forEach(p => { p.style.display = 'none'; });
      panel.style.display = '';
      mega.classList.add('fhdr-mega--visible');
      border?.classList.add('fhdr-bottom-border--hidden');
      navItems.forEach(a => a.classList.toggle('fhdr-nav-item--active', a.dataset.nav === label));
      activeLabel = label;
    }

    function hide() {
      mega.classList.remove('fhdr-mega--visible');
      border?.classList.remove('fhdr-bottom-border--hidden');
      navItems.forEach(a => a.classList.remove('fhdr-nav-item--active'));
      activeLabel = null;
    }

    navItems.forEach(a => {
      const label = a.dataset.nav;
      if (!panels[label]) return; // no panel (e.g. סייל)

      a.addEventListener('mouseenter', () => {
        clearTimeout(closeT);
        clearTimeout(openT);
        openT = setTimeout(() => show(label), 80);
      });
      a.addEventListener('mouseleave', () => {
        clearTimeout(openT);
        closeT = setTimeout(hide, 220);
      });
    });

    mega.addEventListener('mouseenter', () => { clearTimeout(closeT); });
    mega.addEventListener('mouseleave', () => {
      closeT = setTimeout(hide, 130);
    });
  }

  // ── Mobile Drawer ────────────────────────────────────────────────
  function buildDrawerMain(logoSrc, onSelect, onClose) {
    const panel = document.createElement('div');
    panel.className = 'fhdr-panel-main';

    // Header bar
    panel.innerHTML = `
      <div class="fhdr-drawer-header">
        <img src="${logoSrc}" alt="FESTIVE" class="fhdr-drawer-logo">
        <button class="fhdr-drawer-close" aria-label="סגור">${svg.x}</button>
      </div>
      <div class="fhdr-drawer-scroll" id="fhdr-main-scroll"></div>
      <div class="fhdr-drawer-footer">
        <a href="/account" class="fhdr-drawer-footer-link">${svg.user15}<span>חשבון שלי</span></a>
        <a href="/search" class="fhdr-drawer-footer-link" data-fhdr-search-trigger aria-haspopup="dialog">${svg.search15}<span>חיפוש</span></a>
      </div>
    `;

    panel.querySelector('.fhdr-drawer-close').addEventListener('click', onClose);

    const scroll = panel.querySelector('#fhdr-main-scroll');
    NAV.forEach(item => {
      const hasSub = item.cols && item.cols.length;
      const el = document.createElement(hasSub ? 'button' : 'a');
      el.className = 'fhdr-main-item' + (item.sale ? ' fhdr-main-item--sale' : '');
      if (!hasSub) el.href = item.href || '#';

      el.innerHTML = `<span>${item.label}</span>
        ${hasSub ? `<span class="fhdr-main-item__chevron">${svg.chev}</span>` : ''}`;

      if (hasSub) {
        el.addEventListener('click', () => onSelect(item));
      }
      scroll.appendChild(el);
    });

    return panel;
  }

  function buildDrawerSub(logoSrc) {
    const panel = document.createElement('div');
    panel.className = 'fhdr-panel-sub';
    panel.innerHTML = `
      <div class="fhdr-drawer-header" id="fhdr-sub-header">
        <button class="fhdr-drawer-back" id="fhdr-drawer-back">
          ${svg.backChev}<span>חזרה</span>
        </button>
      </div>
      <div class="fhdr-drawer-scroll" id="fhdr-sub-scroll"></div>
    `;
    return panel;
  }

  function populateSubPanel(panel, item) {
    const scroll = panel.querySelector('#fhdr-sub-scroll');
    scroll.innerHTML = '';

    const titleLink = document.createElement('a');
    titleLink.href = item.href || '#';
    titleLink.className = 'fhdr-sub-panel-title';
    titleLink.textContent = item.label;
    scroll.appendChild(titleLink);

    let gi = 0;
    (item.cols || []).forEach(col => {
      if (col.head_thumb) {
        const card = document.createElement('a');
        card.href = col.head_href || '#';
        card.className = 'fhdr-sub-col-card';
        card.innerHTML = `
          <div class="fhdr-sub-col-card-img"><img src="${col.head_thumb}" alt="${col.head}" loading="lazy"></div>
          <span class="fhdr-sub-col-card-label">${col.head}</span>`;
        scroll.appendChild(card);
      } else {
        // No image: reuse the same card styling (typography, colors, layout
        // tokens, hover) minus the image block. Render a real anchor when a URL
        // is available, falling back to a non-clickable div otherwise.
        const hasUrl = col.head_href && col.head_href !== '#';
        const card = document.createElement(hasUrl ? 'a' : 'div');
        if (hasUrl) card.href = col.head_href;
        card.className = 'fhdr-sub-col-card fhdr-sub-col-card--no-img';
        card.innerHTML = `<span class="fhdr-sub-col-card-label">${col.head}</span>`;
        scroll.appendChild(card);
      }

      col.links.forEach(lk => {
        const a = document.createElement('a');
        a.href = lk.href || '#';
        a.className = 'fhdr-sub-link' + (lk.bold ? ' fhdr-sub-link--bold' : '');
        a.style.animationDelay = `${0.18 + gi * 0.045}s`;
        a.textContent = lk.text;
        scroll.appendChild(a);
        gi++;
      });

      if (col.extra) {
        const extraHead = document.createElement('div');
        extraHead.className = 'fhdr-sub-group-head';
        extraHead.textContent = col.extra.head;
        scroll.appendChild(extraHead);

        col.extra.links.forEach(lk => {
          const a = document.createElement('a');
          a.href = lk.href || '#';
          a.className = 'fhdr-sub-link' + (lk.bold ? ' fhdr-sub-link--bold' : '');
          a.style.animationDelay = `${0.18 + gi * 0.045}s`;
          a.textContent = lk.text;
          scroll.appendChild(a);
          gi++;
        });
      }
    });

    const photos = item.photos || [];
    if (photos.length) {
      const photoRow = document.createElement('div');
      photoRow.className = 'fhdr-sub-photos';
      photos.forEach(ph => {
        const inner = `<div class="fhdr-photo-card__img-wrap">
            <img src="${ph.src}" alt="${ph.caption || ''}" loading="lazy">
          </div>
          ${ph.caption ? `<p class="fhdr-photo-card__caption">${ph.caption}</p>` : ''}`;
        photoRow.innerHTML += ph.link
          ? `<a class="fhdr-photo-card fhdr-photo-card--link" href="${ph.link}">${inner}</a>`
          : `<div class="fhdr-photo-card">${inner}</div>`;
      });
      scroll.appendChild(photoRow);
    }
  }

  function initMobileDrawer() {
    const drawer  = document.getElementById('fhdr-drawer');
    const overlay = document.getElementById('fhdr-drawer-overlay');
    const burger  = document.getElementById('fhdr-burger');
    const panels  = document.getElementById('fhdr-drawer-panels');
    if (!drawer || !panels) return;

    const logoSrc = drawer.dataset.logo || '';

    let subPanel = null;

    function open()  {
      drawer.classList.add('fhdr-drawer--open');
      overlay.classList.add('fhdr-drawer-overlay--open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('fhdr-drawer--open');
      overlay.classList.remove('fhdr-drawer-overlay--open');
      document.body.style.overflow = '';
      // Also reset sub panel after drawer closes
      setTimeout(() => {
        if (mainPanel) mainPanel.classList.remove('fhdr-panel-main--hidden');
        if (subPanel)  subPanel.classList.remove('fhdr-panel-sub--visible');
      }, 340);
    }

    function selectCategory(item) {
      mainPanel.classList.add('fhdr-panel-main--hidden');
      populateSubPanel(subPanel, item);
      subPanel.classList.add('fhdr-panel-sub--visible');
    }

    function goBack() {
      mainPanel.classList.remove('fhdr-panel-main--hidden');
      subPanel.classList.remove('fhdr-panel-sub--visible');
    }

    const mainPanel = buildDrawerMain(logoSrc, selectCategory, close);
    subPanel = buildDrawerSub(logoSrc);
    subPanel.querySelector('#fhdr-drawer-back').addEventListener('click', goBack);

    panels.appendChild(mainPanel);
    panels.appendChild(subPanel);

    burger?.addEventListener('click', open);
    overlay?.addEventListener('click', close);
  }

  // ── Cart Drawer ───────────────────────────────────────────────────
  // The drawer itself is the `cart-drawer` section (sections/cart-drawer.liquid),
  // rendered from theme.liquid and powered by cart-drawer.js / cart-items-component.
  // Here we only open it from the header triggers and keep the badges in sync.
  function initCartDrawer() {
    document.querySelectorAll('.fhdr-cart-trigger').forEach(btn => {
      btn.addEventListener('click', e => {
        const drawer = document.querySelector('cart-drawer-component');
        if (!drawer) return; // no drawer on this page (e.g. /cart) — follow the link
        e.preventDefault();
        customElements.whenDefined('cart-drawer-component').then(() => drawer.open());
      });
    });

    function updateBadge(badgeClass, wrapSelector, count) {
      const wrap = document.querySelector(wrapSelector);
      if (!wrap) return;
      let badge = wrap.querySelector('.' + badgeClass);
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = badgeClass;
          wrap.appendChild(badge);
        }
        badge.textContent = count;
      } else {
        badge?.remove();
      }
    }

    // CartAddEvent / CartUpdateEvent both fire as 'cart:update' (see events.js).
    // IMPORTANT: for a product-form add, `itemCount` is the quantity ADDED (a delta),
    // NOT the cart total — same convention the stock cart-icon component relies on.
    // Every other source (cart-items-component, festive-quick-add, …) sends the
    // absolute total. So we ADD the delta to the current badge value for
    // product-form events and SET it directly otherwise. The current value is read
    // back from the rendered badge each time, which keeps it drift-free.
    document.addEventListener('cart:update', e => {
      const data = e.detail?.data || {};
      const n = data.itemCount;
      if (typeof n !== 'number') return; // some sources (e.g. quick-order) omit it — leave badge as-is
      const existing = document.querySelector('.fhdr-cart-badge, .fhdr-mobile-cart-badge');
      const current = existing ? (parseInt(existing.textContent, 10) || 0) : 0;
      const total = data.source === 'product-form-component' ? current + n : n;
      updateBadge('fhdr-cart-badge', '.fhdr-cart-wrap', total);
      updateBadge('fhdr-mobile-cart-badge', '.fhdr-mobile-cart', total);
    });
  }

  // ── Predictive Search Modal ───────────────────────────────────────
  // The modal itself is the `search-modal` snippet (a dialog-component),
  // rendered globally from theme.liquid and powered by dialog.js /
  // predictive-search.js. Header search triggers open it instead of
  // navigating to /search; the <a href> stays as a no-JS fallback.
  // showDialog() opens the native <dialog> and showModal() autofocuses the
  // search input (same behavior the stock theme's search button relies on).
  function initSearchModal() {
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-fhdr-search-trigger]');
      if (!trigger) return;

      const modal = document.getElementById('search-modal');
      // No modal on this page (or not yet upgraded) — follow the link to /search
      if (!modal || typeof modal.showDialog !== 'function') return;

      e.preventDefault();

      // Close the mobile drawer first so the modal isn't stacked behind it
      const drawer = document.getElementById('fhdr-drawer');
      if (drawer && drawer.classList.contains('fhdr-drawer--open')) {
        drawer.classList.remove('fhdr-drawer--open');
        document.getElementById('fhdr-drawer-overlay')?.classList.remove('fhdr-drawer-overlay--open');
        document.body.style.overflow = '';
      }

      modal.showDialog();
    });
  }

  // ── Transparent → solid on scroll + publish --header-height ─────
  function initScrollSolid() {
    const wrap = document.getElementById('fhdr-wrap');
    if (!wrap) return;

    function publishHeight() {
      document.documentElement.style.setProperty('--header-height', wrap.offsetHeight + 'px');
    }

    function update() {
      wrap.classList.toggle('is-scrolled', window.scrollY > 10);
    }

    publishHeight();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', publishHeight, { passive: true });
    window.addEventListener('load',   publishHeight, { passive: true });
  }

  // ── Init ─────────────────────────────────────────────────────────
  function init() {
    initScrollSolid();
    initMegaMenu();
    initMobileDrawer();
    initCartDrawer();
    initSearchModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
